import { FormEnginePlugin } from '@form-engine/core-application';
import { apiName } from './workflow-layers/session-log';
import WorkflowLayer from './workflow-layers/session-log/client';

declare module '@form-engine/core-application/types/form' {
    interface WorkflowLayerDefinitionSubType {
        [apiName]: {
            retention: string;
        };
    }
}

export default {
    workflowLayers: {
        [apiName]: WorkflowLayer,
    },
} as FormEnginePlugin;
